import React, { useContext, useEffect, useState } from "react";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import muteIcon from "../../Assets/Images/mute-icon.png";
import "./CompanionAi.css";
import arrowIcon from "../../Assets/Images/arrow-icon.png";
import { Modal, Button, Tooltip, Form, Select, Input, Alert } from "antd";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import CompanionVoiceSelect from "./CompanionVoiceSelect";
import { voices } from "../VideoAi/api";
import { Howl } from "howler";
import { useRef } from "react";
import { GoEye, GoEyeClosed, GoMute, GoUnmute } from "react-icons/go";
import { IoMdSend } from "react-icons/io";
import ReactMarkdown from "react-markdown";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
// import Avatar from "../Gaming/Avatar";
import {
  handleAiChatCompletions,
  handleAiChatCompletionsVideo,
  handleAiChatCompletionsAssistant,
} from "../../utils/AiApiFunctions";
import reload from "../../Assets/Images/relaoder.png";
import PageHeading_V2 from "../../Components_V2/PageHeading/PageHeading";

const loadingMessages = [
  "Hang tight while we load the awesomeness!",
  "Loading the magic, please wait…",
  "Gathering pixels and data, almost there…",
  "Loading progress bar: Patience is a virtue!",
  "Fetching bits and bytes, just a moment…",
  "Loading brilliance, it’s worth the wait!",
  "One step closer to greatness, loading…",
  "Loading… Grab a snack, we’ll be quick!",
  "Loading the future, stay tuned…",
  "Loading… Meanwhile, enjoy the anticipation!",
  "We’re on it! Loading in progress…",
  "Loading the good stuff, hang in there!",
  "Loading the next big thing, just for you!",
  "Loading… Because good things take time!",
  "Building the excitement, loading…",
  "Loading… Let’s make patience a habit!",
  "Loading… The journey to excellence begins!",
  "Loading… Slow and steady wins the race!",
  "Brace yourself, loading brilliance ahead!",
  "Loading… Your patience is highly appreciated!",
];

const questionsAsk = [
  "What is digital marketing?",
  "How is digital marketing similar to traditional marketing?",
  "Why is an online presence necessary for businesses today?",
  "What are the benefits of having a strong digital presence?",
  "Why is it important to stay updated with digital marketing trends?",
  "What are the core disciplines of digital marketing?",
  "What is the Customer Value Journey?",
  "How does the Customer Value Journey help in business growth?",
  "What are the 8 stages of the Customer Value Journey?",
  "Why is understanding the Customer Value Journey crucial for marketers?",
  "What is content marketing?",
  "How can content marketing attract prospects?",
  "What types of content can be used at the top of the funnel?",
  "What is the role of content marketing in the evaluation stage of the funnel?",
  "What content types are suitable for converting leads into customers?",
  "How does content marketing support the sales process?",
  "What is meant by 'perfect' content?",
  "How does content marketing fit into the overall digital marketing strategy?",
  "What is a Lead Magnet?",
  "What is the Content Lifecycle?",
  "What is digital advertising?",
  "How does paid traffic differ from organic traffic?",
  "What are the top three sources of paid traffic?",
  "How can businesses control paid traffic?",
  "What are the advantages of using paid traffic?",
  "How can paid traffic complement organic traffic?",
  "What is the difference between Google and Facebook ads?",
  "What makes YouTube ads unique?",
  "How should ads be targeted based on the customer journey?",
  "What are the five key elements of a high-performing ad campaign?",
  "What is social media marketing?",
  "How does the Social Success Cycle work?",
  "How can businesses attract fans and followers through social media?",
  "What strategies are effective for engaging social media audiences?",
  "How can social media be used to drive sales?",
  "What role does content play in social media marketing?",
  "How important is community management in social media marketing?",
  "What are some best practices for social media marketing?",
  "How can businesses measure social media marketing success?",
  "What are the challenges of social media marketing?",
  "Why is email marketing still relevant today?",
  "How can email marketing help businesses grow?",
  "What are some best practices for email marketing?",
  "How can email marketing be used to guide customers through the Customer Value Journey?",
  "What metrics should be tracked in email marketing?",
  "What types of emails are effective for engaging subscribers?",
  "How can businesses improve their email open rates?",
  "What role does personalization play in email marketing?",
  "How can email marketing support other digital marketing efforts?",
  "What are the common pitfalls in email marketing?",
  "What is search marketing?",
  "How has search marketing changed in recent years?",
  "What are the key components of search engine optimization (SEO)?",
  "How can search marketing drive website traffic?",
  "What strategies can improve a website's search engine ranking?",
  "What is the role of keywords in search marketing?",
  "How does SEO support other digital marketing disciplines?",
  "What tools can help with search marketing?",
  "How can businesses measure the success of their search marketing efforts?",
  "What are common SEO mistakes to avoid?",
  "What is website analytics?",
  "Why are website analytics important for digital marketers?",
  "How can analytics help identify what's working and what's not?",
  "What are the key metrics to track in website analytics?",
  "How can businesses use analytics to improve their marketing strategies?",
  "What tools are available for website analytics?",
  "How can website analytics guide decision-making in digital marketing?",
  "What are the challenges of using website analytics?",
  "How can analytics help in understanding customer behavior?",
  "What role does data play in digital marketing?",
  "What is conversion rate optimization (CRO)?",
  "Why is CRO critical to digital marketing success?",
  // "What are the key steps in the CRO process?",
  "How can CRO improve marketing campaign performance?",
  "What are common techniques for optimizing conversion rates?",
  "How can A/B testing be used in CRO?",
  "What metrics are important in CRO?",
  "How can CRO be integrated into the overall digital marketing strategy?",
  "What are the challenges of implementing CRO?",
  "How does CRO contribute to business growth?",
  "How do digital marketing strategies differ for B2B and B2C companies?",
  "What role does branding play in digital marketing?",
  "How can digital marketing tactics be aligned with business goals?",
  "What are the best practices for creating a digital marketing strategy?",
  "How does customer feedback influence digital marketing?",
  "What is the importance of having a mobile-friendly digital marketing approach?",
  "How can businesses stay updated with digital marketing trends?",
  "What are the ethical considerations in digital marketing?",
  "How can businesses leverage user-generated content in their digital marketing?",
  "What are some common challenges faced by digital marketers today?",
  "How can businesses create a multi-channel digital marketing strategy?",
  "What is the role of automation in digital marketing?",
  "How can artificial intelligence be used in digital marketing?",
  "What are the key considerations when scaling a digital marketing strategy?",
  "How can businesses optimize their digital marketing budget?",
  "What is the importance of storytelling in digital marketing?",
  "How does influencer marketing fit into digital marketing strategies?",
  "How can businesses use webinars as part of their digital marketing efforts?",
  "What are the future trends in digital marketing?",
  "How can businesses measure the overall ROI of their digital marketing efforts?",
];

const CompanionAi_V2 = () => {
  const { AIuser, tokenLocal, userRefetch, setUserRefetch } =
    useContext(UserAuthContext);
  const [generatingtext, setGeneratingText] = useState("");
  const [text, setText] = useState("");
  const loggedinUser = AIuser?.name;
  const [questions, setQuestions] = useState("What is your name?");
  const [userName, setUserName] = useState("");
  const [loadingMsg, setLoadinMsg] = useState("");
  const [chatbotName, setChatbotName] = useState("");
  const [gender, setGender] = useState("Male");
  const [percent, setPercent] = useState(0);
  const [nameSubmitted, setnameSubmitted] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");
  const [voice, setVoice] = useState(defaultValue);
  const [usingChat, setUsingChat] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [isRestarted, setIsRestarted] = useState(false);
  const [audioDuration, setAudioDuration] = useState();
  const [isPlaying, setIsPlaying] = useState(false);
  const [isShort, setIsShort] = useState(true);
  const [isHaveViewMessage, setIsHaveViewMessage] = useState(false);
  const [randomNumber, setRandomNumber] = useState(
    Math.floor(Math.random() * questionsAsk?.length)
  );
  const [isYes, setIsYes] = useState(false);
  const [messages, setMessages] = useState([
    { author: chatbotName, body: `Hi ${userName}, How can I help you?` },
  ]);

  useEffect(() => {
    if (AIuser?.name) {
      setUserName(AIuser?.name);
    }
  }, [AIuser]);

  const countWordsResponse = (str) => {
    return str.trim().split(/\s+/).filter(Boolean).length;
  };
  const [width, setWidth] = useState("94%");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setWidth("87%");
      } else {
        setWidth("93%");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set the initial value

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [inputText, setInputText] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [nextQues, setNextQues] = useState("1st");
  const inputRef = useRef(null);
  const divRef = useRef(null);
  const [isScrolling, setIsScrolling] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const [voiceCount, setVoiceCount] = useState(1);
  const [finalSubmit, setfinalSubmit] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [showAvatar, setshowAvatar] = useState(false);
  const [arrivalText, setarrivalText] = useState(false);
  const [words, setWords] = useState(0);
  const [audiocontent, setAudioContent] = useState(0);
  const [sound, setSound] = useState(null);
  const [viewMessages, setViewMessages] = useState([]);
  const inputRef2 = useRef(null);
  const wordRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [transactionId, setTransactionId] = useState("");

  useEffect(() => {
    const randomChars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz01234567891011121314156655";
    let result = "";
    for (let i = 0; i < 8; i++) {
      result += randomChars.charAt(
        Math.floor(Math.random() * randomChars.length)
      );
    }
    setTransactionId(result);
  }, []);

  function formatBoldText(text) {
    return text?.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
  }
  const copyMsgs = messages;
  copyMsgs[0].body = `Hi ${userName}, How can I help you?`;

  const handleScroll = (event) => {
    if (event.deltaY > 0) {
      setIsScrolling(false);
    } else if (event.deltaY < 0) {
      setIsScrolling(true);
    }
  };

  useEffect(() => {
    if (isGenerating === true) {
      const handleScroll = () => {
        const scrollTop = inputRef?.current?.scrollTop;
        setIsScrollingUp(scrollTop < inputRef?.current?._prevScrollTop);
        inputRef.current._prevScrollTop = scrollTop;
      };

      inputRef.current._prevScrollTop = 0;
      inputRef.current.addEventListener("scroll", handleScroll);
      const ref = inputRef.current;

      return () => {
        if (ref) {
          ref.removeEventListener("scroll", handleScroll);
        }
      };
    }
  }, [generatingtext, isGenerating]);

  useEffect(() => {
    if (isScrolling === false && isScrollingUp === false) {
      inputRef.current.scrollTop = inputRef.current.scrollHeight;
    }
    console.log(
      isGenerating,
      text,
      isScrolling,
      isScrollingUp,
      generatingtext,
      "all the text",
      text == generatingtext
    );
  }, [text, isScrolling, isScrollingUp]);

  useEffect(() => {
    const worker = new Worker("/worker.js");

    worker.addEventListener("message", (event) => {
      const { text } = event.data;

      if (text !== "Processing...") {
        setText(text);
      }

      setMessages([...messages, { author: chatbotName, body: text }]);
      setInputText("");
      console.log([...messages, { author: chatbotName, body: text }]);
      inputRef.current.focus();
    });

    worker.postMessage({ generatingtext, words });
    return () => {
      worker.terminate();
    };
  }, [generatingtext, isGenerating]);

  const handleSubmitCredits = async (points) => {
    const deductedCredits = AIuser?.credits - points;

    await axios
      .put(
        "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
        { email: AIuser?.email, credits: deductedCredits },
        {
          headers: {
            authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setUserRefetch(!userRefetch);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsHaveViewMessage(false);
    localStorage.setItem("inputText", inputText);

    if (AIuser.credits > 0) {
      setIsGenerating(true);
      setGeneratingText(() => "");
      setText("");
      setIsScrolling(false);
      setIsScrollingUp(false);
      setMessages([...messages, { author: userName, body: inputText }]);
      const prompt = messages.map((message) => message.body).join("\n");
      let question = `${prompt}\n${userName}: ${inputText}\n${chatbotName}:`;

      const response = await handleAiChatCompletionsAssistant(
        question,
        inputText
      );

      if (response) {
        handleSynthesize(response, voice);
        const points = Math.floor(countWordsResponse(response) / 10);
        handleSubmitCredits(points);
        const transactionRes = await axios.post(
          "https://backend.whalesai.com/api/v1/credits-transaction/create",
          {
            aiType: "Consultant Ai",
            transactionId: transactionId,
            requestQues: inputText,
            response: formatBoldText(response),
            credit: points,
            userId: AIuser?._id,
            userName: userName,
            companionName: chatbotName,
            companionAiVoice: voice,
            companionAiGender: gender,
            // userId: "6468c8ab7f567716c118ad6c",
          }
        );

        setTimeout(() => {
          console.log(formatBoldText(response), "formatBoldText(response)");
          setGeneratingText(formatBoldText(response));
          setIsGenerating(false);
        }, 1000);
      } else {
        setGeneratingText("Invalid prompt!");
      }
    } else {
      setShowAlert(true);
    }
  };

  const handleClearInput = () => {
    document.getElementById("inputText").value = "";
    setInputText("");
  };
  const handleKeyDown = (event) => {
    if (
      event.key === "Enter" &&
      inputText !== "" &&
      !event.shiftKey &&
      window.innerWidth > 1000
    ) {
      if (divRef.current) {
        divRef.current.scrollIntoView({ behavior: "smooth" });
      }
      event.preventDefault();
      event.stopPropagation();
      handleSubmit(event);
    }
    if (event.key === "Enter" && event.shiftKey) {
      event.preventDefault();
      setInputText(inputText + "\n");
    }
    if (window.innerWidth < 1000 && event.key === "Enter") {
      event.preventDefault();
      setInputText(inputText + "\n");
    }
  };

  const onFinish = () => {
    if (userName && chatbotName) {
      setnameSubmitted(true);
      setUsingChat(true);

      handleSynthesize("Hi " + userName + ", how can I help you?", voice);
      setIsShort(false);
    }
  };

  const handlePercent = (value) => {
    if (value == "1st") {
      setPercent(35);
    } else if (value == "2nd") {
      setPercent(70);
    } else {
      setPercent(100);
      setTimeout(() => { }, 3000);
    }
  };

  const onChange = (value) => {
    setGender(value);
  };

  const onChangeVoices = (value) => {
    const selectedVoices = voices?.find(
      (voice) => voice.label === value.target.value,
      setChatbotName(value.target.value)
    );
    setVoice(selectedVoices.value);

    setDefaultValue(selectedVoices);
    const latestInput = localStorage.getItem("latestInput");
    handleSynthesize(latestInput, selectedVoices.value);
    // setGender(value);
  };

  useEffect(() => {
    return () => {
      if (sound) {
        sound.stop();
      }
    };
  }, [sound]);

  const toggleMute = () => {
    setIsMuted((isMuted) => !isMuted);
    const muted = isMuted;
    if (sound) {
      sound.mute(!muted);
    }
  };

  const handleSynthesize = async (input, voiceParam) => {
    try {
      localStorage.setItem("latestInput", input);
      // console.log("voiceParam", voiceParam);
      const splittedVoice = voiceParam?.split("-");

      // setVoice(voices?.[randomIndex]?.value);

      const randomVoice = defaultValue?.value;
      const splittedRandomVoice = randomVoice?.split("-");

      const response = await fetch(
        "https://texttospeech.googleapis.com/v1beta1/text:synthesize?key=AIzaSyBnaoRoWAnWm6poRcPrETHcYF0LZryXzw8",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            input: {
              text: input,
            },

            voice: {
              languageCode: voiceParam
                ? `${splittedVoice?.[0]}-${splittedVoice?.[1]}`
                : `${splittedRandomVoice?.[0]}-${splittedRandomVoice?.[1]}`,
              name: voiceParam ? voiceParam : randomVoice,
            },

            audioConfig: {
              audioEncoding: "MP3",
            },
          }),
        }
      );

      const data = await response.json();
      const audioContent = data.audioContent;

      setAudioContent(audioContent);
      const sound = new Howl({
        src: [`data:audio/mp3;base64,${audioContent}`],
        mute: isMuted,
        onload: function () {
          const duration = sound.duration();
          setAudioDuration(duration);
        },
        onplay: function () {
          setIsPlaying(true);
        },
        onend: function () {
          setIsPlaying(false);
        },
      });

      sound.play();
      setSound(sound);
      setIsPlaying(true);
    } catch (err) {
      console.log(err);
    }
  };

  const randomIndex = Math.floor(Math.random() * voices?.length);

  useEffect(() => {
    window.scrollTo(0, 0);
    setDefaultValue(voices?.[randomIndex]);
    setChatbotName(voices?.[randomIndex]?.value);
    setVoice(voices?.[randomIndex]?.value);
  }, []);

  useEffect(() => {
    let i = 0;
    let textQ;
    if (nextQues == "1st") {
      textQ = "What is your name?";
      handleSynthesize("What is your name?", voice);
      setIsYes(false);
    } else if (nextQues == "2nd") {
      textQ = "Which consultant would you like to chat with?";
      handleSynthesize("Which consultant would you like to chat with?", voice);
    }
    const interval = setInterval(() => {
      setQuestions(textQ?.slice(0, i));
      i++;
      if (i > textQ?.length) {
        clearInterval(interval);
        if (nextQues == "2nd") setIsYes(true);
        else setIsYes(false);
      }
    }, 80);
    return () => clearInterval(interval);
  }, [nextQues, loaded, voiceCount, voice]);

  const creditTolcalString = AIuser?.credits
    ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
    : "0";
  useEffect(() => {
    if (location?.state !== null) {
      setIsHaveViewMessage(true);
      setUsingChat(location.state.usingChat);
      setVoice(location.state.companionAiVoice);
      setGender(location.state.companionAiGender);
      setViewMessages(location.state.messages);
      const selectedVoices = voices?.find(
        (voice) => voice?.value === location?.state?.companionAiVoice
      );
      setDefaultValue(selectedVoices);
    }
  }, [location.state]);

  if (location.pathname == "/consultant-ai-app") {
  } else if (location.pathname == "/ver2/consultant-ai") {
  }

  // Function to scroll textarea to bottom

  useEffect(() => {
    divRef.current.scrollTop = divRef.current.scrollHeight;
  }, [messages]);
  const nothing = (e) => {
    e.preventDefault();
  };

  return (
    <div className="h-100 companion-ai-container">
      {location?.pathname == "/ver2/consultant-ai" && (
        <PageHeading_V2
          title={"SOCIAL MEDIA CONSULTANT"}
          description={
            "The Social Media Consultant is designed to assist with your social media marketing efforts."
          }
        />
      )}
      <div
        className="companion-ai-main"
        style={{
          maxWidth: "872px",
          paddingInline: "12px",
          marginInline: "auto",
        }}
      >
        <div className="CreditDiv">
          <button className="credits-button">
            CREDITS : {creditTolcalString}
          </button>
          {location?.pathname == "/consultant-ai-app" ? (
            <button
              className="buy-credits-button"
              onClick={() => navigate(`/purchase-app/${tokenLocal}`)}
            >
              BUY CREDITS
            </button>
          ) : (
            <button
              className="buy-credits-button"
              onClick={() => navigate("/ver2/purchase")}
            >
              BUY CREDITS
            </button>
          )}
          {location.pathname == "/consultant-ai-app" ? (
            <button
              onClick={() => navigate("/transaction-app")}
              className="money-exchange-button"
            >
              <img src={moneyExchangeIcon} alt="moneyExchangeIcon" />
            </button>
          ) : (
            <button
              onClick={() => navigate("/ver2/usage")}
              className="money-exchange-button"
            >
              <img src={moneyExchangeIcon} alt="moneyExchangeIcon" />
            </button>
          )}
        </div>
        <p
          style={{ fontSize: "8px" }}
          className="text-white mb-0 mt-2 text-center"
        >
          1 Credit per 10 words
        </p>
        <div className="selectDiv mt-4 d-flex align-items-center justify-content-between">
          <p
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/ver2/do-it-yourself")}
            className="text-warning m-0"
          >
            Click here to generate contents
          </p>
          {isMuted ? (
            <Tooltip placement="top" title={"Mute"}>
              <GoMute
                className="chatai-icon-styles text-light"
                style={{
                  marginLeft: "5px",
                  fontSize: "28px",

                  cursor: "pointer",
                }}
                onClick={toggleMute}
              />
            </Tooltip>
          ) : (
            <Tooltip placement="top" title={"Unmute"}>
              <GoUnmute
                className="chatai-icon-styles text-light"
                style={{
                  marginLeft: "5px",

                  fontSize: "28px",
                  cursor: "pointer",
                }}
                onClick={toggleMute}
              />
            </Tooltip>
          )}
        </div>
        <div className="first-field-container">
          <div
            className="companion-res-area p-3"
            ref={divRef}
            style={{ overflowY: "auto", maxHeight: "400px" }}
          >
            <div className="" ref={inputRef} onWheel={handleScroll}>
              <div class="media mb-3">
                <>
                  <div class="media-body ml-3">
                    <div
                      className="text-light rounded  text-start ask-ai-fonts copy-contents"
                      ref={wordRef}
                    >
                      {showAlert == false ? (
                        <>
                          {usingChat ? (
                            <>
                              {isHaveViewMessage ? (
                                <>
                                  {viewMessages?.map((message, i) => {
                                    return (
                                      console.log("viewMessages", message),
                                      (
                                        <div className="mb-4" key={i}>
                                          <div
                                            style={{
                                              color: "black",
                                            }}
                                          >
                                            <span
                                              className="chat-author text-uppercase"
                                              style={{
                                                fontWeight: "bold",
                                                color: "#a500b7",
                                              }}
                                            >
                                              {message?.userName}:
                                            </span>{" "}
                                            {message.userQues}
                                          </div>
                                          <div
                                            className="mb-4"
                                            style={{
                                              color: "black",
                                              whiteSpace: "pre-line",
                                            }}
                                          >
                                            <span
                                              className="chat-author text-uppercase"
                                              style={{
                                                fontWeight: "bold",
                                                color: "#003991",
                                              }}
                                            >
                                              {message?.companionName}:
                                            </span>{" "}
                                            <p
                                              dangerouslySetInnerHTML={{
                                                __html: formatBoldText(
                                                  message.companionAns
                                                ),
                                              }}
                                            ></p>
                                          </div>
                                        </div>
                                      )
                                    );
                                  })}
                                </>
                              ) : (
                                <>
                                  {messages?.map((message, i) => {
                                    const isHuman = message?.author == userName;
                                    console.log(message?.body, "amar message");
                                    return (
                                      <div key={i}>
                                        {isHuman ? (
                                          <div
                                            className="mb-4"
                                            style={{
                                              color: "black",
                                            }}
                                          >
                                            <span
                                              className="chat-author text-uppercase"
                                              style={{
                                                fontWeight: "bold",
                                                color: "#003991",
                                              }}
                                            >
                                              {userName}:
                                            </span>{" "}
                                            {message?.body}
                                            {isGenerating && (
                                              <span className="mb-4 d-block text-to-animate-constant">
                                                Your consultant is thinking …
                                              </span>
                                            )}
                                          </div>
                                        ) : (
                                          <>
                                            {message?.body && (
                                              <div
                                                className="mb-4"
                                                style={{
                                                  color: "black",
                                                  whiteSpace: "pre-line",
                                                }}
                                              >
                                                <span
                                                  className="chat-author text-uppercase textContainer"
                                                  style={{
                                                    color: "#003991",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  {chatbotName}:
                                                </span>{" "}
                                                <span
                                                  style={{
                                                    color: "black",
                                                    whiteSpace: "pre-line",
                                                  }}
                                                  dangerouslySetInnerHTML={{
                                                    __html: formatBoldText(
                                                      message.body
                                                    ),
                                                  }}
                                                ></span>
                                                {message.body}
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    );
                                  })}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <p class="mb-0 text-dark">
                                {<ReactMarkdown>{questions}</ReactMarkdown>}
                              </p>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <Alert
                            message="You don't have enough credits! Please buy credits to continue."
                            type="error"
                            showIcon
                          />
                        </>
                      )}
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
        {nameSubmitted ? (
          <>
            <div className="second-field-container position-relative">
              <form className="text-ai-rep-form form ">
                <textarea
                  style={{ width: width }}
                  className="second-text-area"
                  type="text"
                  lang="en"
                  placeholder=""
                  value={inputText}
                  id="inputText"
                  name="inputBox"
                  onKeyDown={handleKeyDown}
                  ref={inputRef2}
                  onChange={(e) => {
                    setInputText(e.target.value);
                    setUsingChat(true);
                    setText("");
                  }}
                ></textarea>

                <button
                  className="arrow-button send h-70"
                  onClick={inputText?.length != 0 ? handleSubmit : nothing}
                  disabled={false}
                  style={{
                    cursor: inputText?.length === 0 ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src={arrowIcon}
                    alt="image"
                    style={{
                      filter:
                        inputText?.length === 0
                          ? "invert(66%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(86%)"
                          : "none",
                    }}
                  />
                </button>
              </form>
            </div>

            <div className="text-center">
              <p
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (text == generatingtext || text == "") {
                    if (!isGenerating) {
                      setInputText(questionsAsk[randomNumber]);
                      setUsingChat(true);
                      setText("");
                      let number = Math.floor(
                        Math.random() * questionsAsk?.length
                      );
                      if (number == randomNumber) {
                        number = Math.floor(
                          Math.random() * questionsAsk?.length
                        );
                      }
                      setRandomNumber(number);
                    }
                  }
                }}
                className="text-white text-center"
              >
                <span className="text-warning ">You can ask: </span>
                {questionsAsk[randomNumber]}
              </p>

              <img
                onClick={() => {
                  let number = Math.floor(Math.random() * questionsAsk?.length);
                  if (number == randomNumber) {
                    number = Math.floor(Math.random() * questionsAsk?.length);
                  }
                  setRandomNumber(number);
                }}
                style={{ cursor: "pointer" }}
                src={reload}
                alt="reload"
                width="30"
                height="30"
                className="mb-0"
              />
            </div>
            <div
              style={{ marginBottom: "10px", marginTop: "10px" }}
              className="ai-clearbtn d-flex align-items-center justify-content-center"
            >
              {inputText.length > 0 && (
                <button
                  className="comp-clear-button "
                  onClick={handleClearInput}
                >
                  CLEAR
                </button>
              )}
            </div>
          </>
        ) : (
          <div className="d-flex w-100 first-field-container">
            <Form
              name="normal_login"
              className="login-form w-100"
              initialValues={{
                remember: true,
              }}
              layout="vertical"
            >
              {nextQues == "1st" ? (
                <>
                  <Form.Item
                    className="mb-2"
                    name="userName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your Name!",
                      },
                    ]}
                    required
                  >
                    <input
                      className="text-dark selector-second"
                      style={{ borderRadius: "4px 0 0 4px" }}
                      defaultValue={AIuser?.name}
                      placeholder={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </Form.Item>
                </>
              ) : nextQues == "2nd" ? (
                <Form.Item
                  className="mb-2"
                  name="chatbotName"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your chatbot Name!",
                    },
                  ]}
                  required
                >
                  <CompanionVoiceSelect
                    onChangeVoices={onChangeVoices}
                    // onChange={setChatbotName(onChangeVoices.target.value)}
                    defaultValue={defaultValue}
                    setDefaultValue={setDefaultValue}
                    setVoice={setVoice}
                    voices={voices}
                  />
                </Form.Item>
              ) : nextQues == "3rd" ? (
                <select
                  className="selector-second mb-2 h-70"
                  style={{ borderRadius: "4px 0 0 4px" }}
                  name=""
                  id=""
                  onChange={onChange}
                >
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              ) : null}
              {nextQues == "1st" ? (
                <div className="d-flex justify-content-between text-uppercase">
                  <Form.Item></Form.Item>

                  <Form.Item></Form.Item>
                </div>
              ) : nextQues == "2nd" ? (
                <>
                  <div className="d-flex justify-content-between text-uppercase">
                    {isYes && (
                      <Form.Item>
                        <Button
                          type="warning"
                          className="login-form-button me-2 bg-warning text-uppercase"
                          variant="contained"
                          onClick={() => {
                            setNextQues("1st");
                            setIsYes(false);
                            setVoiceCount(voiceCount + 1);
                            setPercent(0);
                          }}
                        >
                          Back
                        </Button>
                      </Form.Item>
                    )}
                    <Form.Item></Form.Item>
                  </div>
                </>
              ) : nextQues == "3rd" ? (
                <>
                  <div className="d-flex justify-content-between text-uppercase">
                    <Form.Item>
                      <Button
                        type="warning"
                        // htmlType="submit"
                        className="login-form-button me-2 bg-warning text-uppercase"
                        onClick={() => {
                          setNextQues("2nd");
                          setVoiceCount(voiceCount + 1);
                          setPercent(35);
                        }}
                      >
                        Back
                      </Button>
                    </Form.Item>
                    <Form.Item></Form.Item>
                  </div>
                </>
              ) : null}
            </Form>
            {
              <button
                // style={{ height: "32px" }}
                className="arrow-button arrow"
                onClick={() => {
                  console.log(nextQues, userName, chatbotName);
                  if (nextQues == "1st") {
                    if (userName) {
                      handlePercent("1st");
                      setNextQues("2nd");
                      setVoiceCount(voiceCount + 1);
                    }
                  }
                  if (nextQues == "2nd") {
                    console.log("work");
                    if (chatbotName) {
                      setNextQues("4th");
                      setVoiceCount(voiceCount + 2);
                      setfinalSubmit(true);
                      onFinish();
                    }
                  }
                  if (nextQues == "3rd") {
                    setfinalSubmit(true);
                    onFinish();
                  }
                }}
              // disabled={!loaded}
              >
                <img style={{ maxWidth: "21px" }} src={arrowIcon} alt="image" />
              </button>
            }
          </div>
        )}
      </div>
      <div class="d-flex justify-content-center mt-0 pt-0">
        <Button
          type="primary"
          htmlType={"submit"}
          className="login-form-button text-uppercase mb-2"
          onClick={() => window.location.reload()}
        >
          RE-START
        </Button>
      </div>
      <div className="animate text-md-center text-lg-center  text-center d-flex justify-content-center mb-5 force-small-font">
        Please do not navigate away from the browser.
        <br /> Doing so will stop the process.
      </div>
      <p className="mt-5"></p>
    </div>
  );
};

export default CompanionAi_V2;